export default "__VITE_ASSET__CRJ0J0cY__"